import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';

export const conciergeLoginThunk = createAsyncThunk(
    `ConciergeLoginSlicer/conciergeLoginThunk`,
    async (_, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
        };

        const { data } = await conciergeApiClient.post('Participant/login', _, { headers });
        return data;
    }
);

const initialState = {
    dataConciergeLogin: false,
    loadingConciergeLogin: false,
    errorConciergeLogin: false,
};

const ConciergeLoginSlicer = createSlice({
    name: 'conciergeLogin',
    initialState,
    reducers: {
        resetDataConciergeLogin: (state) => {
            state.dataConciergeLogin = false;
            state.loadingConciergeLogin = false;
            state.errorConciergeLogin = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(conciergeLoginThunk.pending, (state) => {
            state.dataConciergeLogin = false;
            state.loadingConciergeLogin = true;
            state.errorConciergeLogin = false;
        });
        builder.addCase(conciergeLoginThunk.fulfilled, (state, action) => {
            state.dataConciergeLogin = true;
            state.loadingConciergeLogin = false;
            state.errorConciergeLogin = false;
        });
        builder.addCase(conciergeLoginThunk.rejected, (state) => {
            state.loadingConciergeLogin = false;
            state.errorConciergeLogin = true;
            state.dataConciergeLogin = false;
        });
    },
});

export const { resetDataConciergeLogin } = ConciergeLoginSlicer.actions;
export default ConciergeLoginSlicer.reducer;